import { createSlice } from '@reduxjs/toolkit';
import { THEME_CONFIG } from 'configs/AppConfig';

const initialState = {
	languages: [],
};

export const cacheSlice = createSlice({
	name: 'cache',
	initialState,
	reducers: {
		setLanguages: (state, action) => {
			state.languages = action.payload;
		},
	},
});

export const { setLanguages } = cacheSlice.actions;

export default cacheSlice.reducer;
